import stylesheet from './tile.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTTile extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const element = document.createElement('div');
        element.classList.add('tile')
        element.innerHTML = `
            <div class="title"></div>
            <div class="content"></div>
        `;
        this.cloneSlotContentIntoContainer(element.querySelector('.title'), 'title');
        this.cloneDefaultSlotContentIntoContainer(element.querySelector('.content'), false);
        return element;
    }

}

customElements.define('nxt-tile', NXTTile);
